import styled from 'styled-components';
import { getThemeByPath } from '~/utils';
import Typography from '../Typography';

const defaultBtnWidth = 200;
const defaultBtnWidthMobile = 120;

const secondaryMain = getThemeByPath('colors.secondary.main');

const radiusMedium = getThemeByPath('radius.medium');

const spacingShort = getThemeByPath('spacings.short');

const bkpTablet = getThemeByPath('breakpoints.tablet');

export const ButtonIconWrapper = styled.button`
  width: ${defaultBtnWidth}px;
  display: flex;
  height: fit-content;
  flex-direction: column;
  align-items: center;
  background-color: ${secondaryMain};
  border-radius: ${radiusMedium}px;
  padding: ${spacingShort}px;

  @media (max-width: ${bkpTablet}px) {
    width: ${defaultBtnWidthMobile}px;
  }
`;

export const ButtonTextWrapper = styled.div``;

export const ButtonIconText = styled(Typography).attrs({
  variant: 'headline6',
  textColor: 'colors.primary.main',
  typographyProps: {
    style: {
      fontWeight: 500,
    },
  },
})``;

export const IconWrapper = styled.div`
  margin-top: ${spacingShort}px;
`;
